import photo1 from "../../assests/about_section/photo1.webp"
import photo2 from "../../assests/about_section/photo2.webp"
import photo3 from "../../assests/about_section/photo3.webp"
import icon3 from '../../assests/about_section/icon3.svg'
import icon1 from '../../assests/about_section/icon1.svg'
import icon2 from '../../assests/about_section/icon2.svg'
export const aboutData={
    heading1:'Market Driven-Development',
    subheading1:'Bridging the gap between your vision and audience needs.',
    photo1:photo1,
    icon1:icon1,
    heading2:'Future-Forward Experiences',
    subheading2:'Designing and building websites with cutting-edge AI and prompt engineering.',
    photo2:photo2,
    icon2:icon2,
    heading3:"Streamlined Solutions",
    subheading3:'Delivering efficient, tech-savvy projects on your time.',
    photo3:photo3,
    icon3:icon3,
}